var map = {
	"./404.svg": [
		87180,
		9,
		87180
	],
	"./Check.svg": [
		84802,
		9,
		84802
	],
	"./Icon/MenuIcon/About.svg": [
		81558,
		9,
		81558
	],
	"./Icon/MenuIcon/Blog.svg": [
		97759,
		9,
		97759
	],
	"./Icon/MenuIcon/Clients.svg": [
		14781,
		9,
		14781
	],
	"./Icon/MenuIcon/Compliance.svg": [
		8975,
		9,
		8975
	],
	"./Icon/MenuIcon/ContactSales.svg": [
		56930,
		9,
		56930
	],
	"./Icon/MenuIcon/Docs.svg": [
		40348,
		9,
		40348
	],
	"./Icon/MenuIcon/Events.svg": [
		90232,
		9,
		90232
	],
	"./Icon/MenuIcon/JoinUs.svg": [
		62689,
		9,
		62689
	],
	"./Icon/MenuIcon/Legal.svg": [
		43075,
		9,
		43075
	],
	"./Icon/MenuIcon/Partners.svg": [
		92225,
		9,
		92225
	],
	"./Icon/MenuIcon/Press.svg": [
		31624,
		9,
		31624
	],
	"./Icon/MenuIcon/Pricing.svg": [
		85530,
		9,
		85530
	],
	"./Icon/MenuIcon/Support.svg": [
		63585,
		9,
		63585
	],
	"./Icon/MenuIcon/Wallet.svg": [
		19422,
		9,
		19422
	],
	"./Icon/MenuIcon/WalletAsAService.svg": [
		30765,
		9,
		30765
	],
	"./Icon/MenuIcon/WalletPricing.svg": [
		22855,
		9,
		22855
	],
	"./Icon/MenuIcon/row.svg": [
		75267,
		9,
		75267
	],
	"./Icon/search-icon1.svg": [
		51403,
		9,
		51403
	],
	"./Icon/search-icon2.svg": [
		6065,
		9,
		6065
	],
	"./Mainpage/Banner/Image1.webp": [
		16148,
		9,
		56315
	],
	"./Mainpage/Banner/left.svg": [
		54544,
		9,
		54544
	],
	"./Mainpage/Banner/lines.svg": [
		10834,
		9,
		10834
	],
	"./Mainpage/Banner/mask.svg": [
		99637,
		9,
		99637
	],
	"./Mainpage/Banner/right.svg": [
		56527,
		9,
		56527
	],
	"./Mainpage/CTA/Bottom.svg": [
		23317,
		9,
		23317
	],
	"./Mainpage/CTA/Top.svg": [
		91764,
		9,
		91764
	],
	"./Mainpage/Feature/FeatureIcon1.svg": [
		96895,
		9,
		96895
	],
	"./Mainpage/Feature/FeatureIcon2.svg": [
		51979,
		9,
		51979
	],
	"./Mainpage/Feature/FeatureIcon3.svg": [
		344,
		9,
		344
	],
	"./Mainpage/Feature/FeatureIcon4.svg": [
		98633,
		9,
		98633
	],
	"./Mainpage/Feature/FeatureIcon5.svg": [
		55965,
		9,
		55965
	],
	"./Mainpage/Feature/FeatureIcon6.svg": [
		91904,
		9,
		91904
	],
	"./Mainpage/Feature/favicon.png": [
		27430,
		9,
		27430
	],
	"./Mainpage/Feature/feature1.png": [
		18725,
		9,
		18725
	],
	"./Mainpage/Partners/YJ.svg": [
		44504,
		9,
		44504
	],
	"./Mainpage/Partners/argo.svg": [
		29889,
		9,
		29889
	],
	"./Mainpage/Partners/partner1.svg": [
		94562,
		9,
		94562
	],
	"./Mainpage/Partners/partner10.svg": [
		94341,
		9,
		94341
	],
	"./Mainpage/Partners/partner11.svg": [
		68918,
		9,
		68918
	],
	"./Mainpage/Partners/partner12.svg": [
		17528,
		9,
		17528
	],
	"./Mainpage/Partners/partner14.svg": [
		268,
		9,
		268
	],
	"./Mainpage/Partners/partner15.svg": [
		99213,
		9,
		99213
	],
	"./Mainpage/Partners/partner16.svg": [
		59067,
		9,
		59067
	],
	"./Mainpage/Partners/partner17.svg": [
		53956,
		9,
		53956
	],
	"./Mainpage/Partners/partner18.svg": [
		29820,
		9,
		29820
	],
	"./Mainpage/Partners/partner19.svg": [
		5377,
		9,
		5377
	],
	"./Mainpage/Partners/partner2.svg": [
		33394,
		9,
		33394
	],
	"./Mainpage/Partners/partner20.svg": [
		75150,
		9,
		75150
	],
	"./Mainpage/Partners/partner21.svg": [
		68840,
		9,
		68840
	],
	"./Mainpage/Partners/partner22.svg": [
		76603,
		9,
		76603
	],
	"./Mainpage/Partners/partner24.svg": [
		82091,
		9,
		82091
	],
	"./Mainpage/Partners/partner25.svg": [
		13205,
		9,
		13205
	],
	"./Mainpage/Partners/partner26.svg": [
		52343,
		9,
		52343
	],
	"./Mainpage/Partners/partner27.svg": [
		81449,
		9,
		81449
	],
	"./Mainpage/Partners/partner28.svg": [
		9837,
		9,
		9837
	],
	"./Mainpage/Partners/partner29.svg": [
		71128,
		9,
		71128
	],
	"./Mainpage/Partners/partner3.svg": [
		66314,
		9,
		66314
	],
	"./Mainpage/Partners/partner30.svg": [
		28996,
		9,
		28996
	],
	"./Mainpage/Partners/partner31.svg": [
		38819,
		9,
		38819
	],
	"./Mainpage/Partners/partner32.svg": [
		94756,
		9,
		94756
	],
	"./Mainpage/Partners/partner33.svg": [
		61447,
		9,
		61447
	],
	"./Mainpage/Partners/partner34.svg": [
		74777,
		9,
		74777
	],
	"./Mainpage/Partners/partner35.svg": [
		96025,
		9,
		96025
	],
	"./Mainpage/Partners/partner36.svg": [
		92754,
		9,
		92754
	],
	"./Mainpage/Partners/partner37.svg": [
		71048,
		9,
		71048
	],
	"./Mainpage/Partners/partner38.svg": [
		25329,
		9,
		25329
	],
	"./Mainpage/Partners/partner39.svg": [
		25059,
		9,
		25059
	],
	"./Mainpage/Partners/partner4.svg": [
		47180,
		9,
		47180
	],
	"./Mainpage/Partners/partner40.svg": [
		34682,
		9,
		34682
	],
	"./Mainpage/Partners/partner41.svg": [
		64081,
		9,
		64081
	],
	"./Mainpage/Partners/partner42.svg": [
		82519,
		9,
		82519
	],
	"./Mainpage/Partners/partner43.svg": [
		58303,
		9,
		58303
	],
	"./Mainpage/Partners/partner44.svg": [
		88791,
		9,
		88791
	],
	"./Mainpage/Partners/partner45.svg": [
		82331,
		9,
		82331
	],
	"./Mainpage/Partners/partner46.svg": [
		95285,
		9,
		95285
	],
	"./Mainpage/Partners/partner47.svg": [
		82699,
		9,
		82699
	],
	"./Mainpage/Partners/partner48.svg": [
		10155,
		9,
		10155
	],
	"./Mainpage/Partners/partner49.svg": [
		68735,
		9,
		68735
	],
	"./Mainpage/Partners/partner5.svg": [
		50993,
		9,
		50993
	],
	"./Mainpage/Partners/partner50.svg": [
		71400,
		9,
		71400
	],
	"./Mainpage/Partners/partner51.svg": [
		28795,
		9,
		28795
	],
	"./Mainpage/Partners/partner6.svg": [
		27280,
		9,
		27280
	],
	"./Mainpage/Partners/partner7.svg": [
		76382,
		9,
		76382
	],
	"./Mainpage/Partners/partner8.svg": [
		99554,
		9,
		99554
	],
	"./Mainpage/Partners/partner9.svg": [
		47826,
		9,
		47826
	],
	"./Mainpage/Partners/sinxi.svg": [
		86682,
		9,
		86682
	],
	"./Mainpage/Partners/zhong.svg": [
		71415,
		9,
		71415
	],
	"./Mainpage/Service/ServiceImage1.png": [
		13170,
		9,
		13170
	],
	"./Mainpage/Service/ServiceImage1.webp": [
		57797,
		9,
		57797
	],
	"./Mainpage/Service/ServiceImage2.png": [
		58069,
		9,
		58069
	],
	"./Mainpage/Service/ServiceImage2.webp": [
		62706,
		9,
		62706
	],
	"./Mainpage/WalletFeatures/appTabIcon1.svg": [
		60833,
		9,
		60833
	],
	"./Mainpage/WalletFeatures/appTabIcon2.svg": [
		34664,
		9,
		34664
	],
	"./Mainpage/WalletFeatures/appTabIcon3.svg": [
		19632,
		9,
		19632
	],
	"./Mainpage/WalletFeatures/appTabIcon4.svg": [
		32697,
		9,
		32697
	],
	"./Mainpage/WalletFeatures/appTabIcon5.svg": [
		13520,
		9,
		13520
	],
	"./Mainpage/WalletFeatures/appTabIcon6.svg": [
		27468,
		9,
		27468
	],
	"./Mainpage/WalletFeatures/slide1.webp": [
		29504,
		9
	],
	"./Mainpage/WalletFeatures/slide2.webp": [
		2253,
		9
	],
	"./Mainpage/WalletFeatures/slide3.webp": [
		20169,
		9
	],
	"./Mainpage/WalletFeatures/slide4.webp": [
		21982,
		9
	],
	"./Mainpage/WalletFeatures/slide5.webp": [
		84641,
		9
	],
	"./Mainpage/WalletFeatures/slide6.webp": [
		85474,
		9
	],
	"./Mainpage/aboutUs/GO.svg": [
		44232,
		9,
		44232
	],
	"./Mainpage/aboutUs/bottom.svg": [
		35602,
		9,
		35602
	],
	"./Mainpage/aboutUs/down.svg": [
		20861,
		9,
		20861
	],
	"./Mainpage/aboutUs/icon.svg": [
		41638,
		9,
		41638
	],
	"./Mainpage/aboutUs/top.svg": [
		10620,
		9,
		10620
	],
	"./Mainpage/hi/Top.svg": [
		72566,
		9,
		72566
	],
	"./Mainpage/studio/studioBG.svg": [
		12942,
		9,
		12942
	],
	"./Mainpage/studio/studioImage.webp": [
		44438,
		9,
		44438
	],
	"./Mainpage/studio/studioMask.svg": [
		38845,
		9,
		38845
	],
	"./Wallet/Comparison1.webp": [
		18974,
		9,
		18974
	],
	"./Wallet/Comparison2.svg": [
		37580,
		9,
		37580
	],
	"./Wallet/Wallet1.webp": [
		86628,
		9,
		86628
	],
	"./Wallet/Wallet2.webp": [
		56866,
		9,
		56866
	],
	"./Wallet/Wallet3.webp": [
		47186,
		9,
		47186
	],
	"./Wallet/Wallet4.webp": [
		53976,
		9,
		53976
	],
	"./Wallet/Wallet5.webp": [
		56833,
		9,
		56833
	],
	"./about/Award.svg": [
		52775,
		9,
		52775
	],
	"./about/CAMS.svg": [
		47054,
		9,
		47054
	],
	"./about/ISO.svg": [
		41835,
		9,
		41835
	],
	"./about/Patent.svg": [
		62341,
		9,
		62341
	],
	"./about/StudioProductLaunch.webp": [
		26883,
		9,
		26883
	],
	"./about/Team/Beans.svg": [
		80183,
		9,
		80183
	],
	"./about/Team/Charles.svg": [
		82687,
		9,
		82687
	],
	"./about/Team/Default-.svg": [
		67371,
		9,
		67371
	],
	"./about/Team/Default.svg": [
		13085,
		9,
		13085
	],
	"./about/Team/Dorara.svg": [
		95628,
		9,
		95628
	],
	"./about/Team/Estelle.svg": [
		60407,
		9,
		60407
	],
	"./about/Team/Grace.svg": [
		85297,
		9,
		85297
	],
	"./about/Team/Harry.svg": [
		94943,
		9,
		94943
	],
	"./about/Team/Jason.svg": [
		27768,
		9,
		27768
	],
	"./about/Team/Jean.svg": [
		31770,
		9,
		31770
	],
	"./about/Team/Kordan.svg": [
		2335,
		9,
		2335
	],
	"./about/Team/Kuan.svg": [
		20441,
		9,
		20441
	],
	"./about/Team/Maggie.svg": [
		79018,
		9,
		79018
	],
	"./about/Team/Pippen.svg": [
		73895,
		9,
		73895
	],
	"./appClassic/appSlider1.png": [
		21402,
		9,
		21402
	],
	"./appClassic/appSlider2.png": [
		89837,
		9,
		89837
	],
	"./appClassic/appSlider3.png": [
		33427,
		9,
		33427
	],
	"./appModern/search.svg": [
		69997,
		9,
		69997
	],
	"./assetPro/description/SubDesc1.svg": [
		80561,
		9,
		80561
	],
	"./assetPro/description/SubDesc2.svg": [
		55779,
		9,
		55779
	],
	"./assetPro/description/SubDesc3.svg": [
		63758,
		9,
		63758
	],
	"./assetPro/description/SubDesc4.svg": [
		8027,
		9,
		8027
	],
	"./assetPro/description/SubDesc5.svg": [
		28687,
		9,
		28687
	],
	"./assetPro/description/SubDesc6.svg": [
		74606,
		9,
		74606
	],
	"./assetPro/description/SubDesc7.svg": [
		15015,
		9,
		15015
	],
	"./assetPro/description/SubDesc8.svg": [
		99769,
		9,
		99769
	],
	"./assetPro/featureBanner/image1.avif": [
		31931,
		9,
		31931
	],
	"./assetPro/featureBanner/image2.avif": [
		11621,
		9,
		11621
	],
	"./assetPro/featureBanner/image3.avif": [
		65017,
		9,
		44401
	],
	"./assetPro/featureBanner/image4.avif": [
		40903,
		9,
		40903
	],
	"./assetPro/featureBanner/image5.avif": [
		90301,
		9,
		90301
	],
	"./assetPro/featureBanner/image6.avif": [
		15124,
		9,
		15124
	],
	"./assetPro/featureBanner/image7.avif": [
		66435,
		9,
		66435
	],
	"./assetPro/featureBanner/image8.avif": [
		34042,
		9,
		34042
	],
	"./button/AppDownloadAppStore.svg": [
		4378,
		9,
		4378
	],
	"./button/AppDownloadAppStoreWhite.svg": [
		30622,
		9,
		30622
	],
	"./button/AppDownloadGooglePlay.svg": [
		16723,
		9,
		16723
	],
	"./button/AppDownloadGooglePlayWhite.svg": [
		91372,
		9,
		91372
	],
	"./chainIcon/ARB.svg": [
		26205,
		9,
		26205
	],
	"./chainIcon/BNB.svg": [
		15653,
		9,
		15653
	],
	"./chainIcon/BSC.svg": [
		14407,
		9,
		14407
	],
	"./chainIcon/BTC.svg": [
		74220,
		9,
		74220
	],
	"./chainIcon/ETH.svg": [
		71197,
		9,
		71197
	],
	"./chainIcon/KCC.svg": [
		83575,
		9,
		83575
	],
	"./chainIcon/Oasys.svg": [
		14226,
		9,
		14226
	],
	"./chainIcon/Polygon.svg": [
		39199,
		9,
		39199
	],
	"./chainIcon/Ronin.svg": [
		15876,
		9,
		15876
	],
	"./chainIcon/Solana.svg": [
		61805,
		9,
		61805
	],
	"./chainIcon/TRON.svg": [
		1931,
		9,
		54090
	],
	"./chevron-down-double.svg": [
		33462,
		9,
		33462
	],
	"./clients/Absolute.svg": [
		3449,
		9,
		3449
	],
	"./clients/client1.svg": [
		34309,
		9,
		34309
	],
	"./clients/client2.svg": [
		63434,
		9,
		63434
	],
	"./clients/hoya.svg": [
		6824,
		9,
		6824
	],
	"./clients/invention.svg": [
		83528,
		9,
		83528
	],
	"./clients/uchiu.svg": [
		45733,
		9,
		45733
	],
	"./clientsNew/ACE.svg": [
		45967,
		9,
		45967
	],
	"./clientsNew/Asia.svg": [
		41719,
		9,
		41719
	],
	"./clientsNew/BitAsset.svg": [
		62574,
		9,
		62574
	],
	"./clientsNew/BitYacht.svg": [
		62132,
		9,
		62132
	],
	"./clientsNew/Bitcool.svg": [
		91106,
		9,
		91106
	],
	"./clientsNew/Bullion.svg": [
		40255,
		9,
		40255
	],
	"./clientsNew/CoolBit.svg": [
		87356,
		9,
		87356
	],
	"./clientsNew/FANSI.svg": [
		57583,
		9,
		57583
	],
	"./clientsNew/GoldBit.svg": [
		37821,
		9,
		37821
	],
	"./clientsNew/HoyaBit.svg": [
		80588,
		9,
		80588
	],
	"./clientsNew/InVar.svg": [
		33133,
		9,
		33133
	],
	"./clientsNew/Jcard.svg": [
		82671,
		9,
		82671
	],
	"./clientsNew/JinNiuBaiHui.svg": [
		13567,
		9,
		13567
	],
	"./clientsNew/Joinbit.svg": [
		38019,
		9,
		6236
	],
	"./clientsNew/MARS.svg": [
		68295,
		9,
		68295
	],
	"./clientsNew/Ministry.svg": [
		95096,
		9,
		95096
	],
	"./clientsNew/OURSONG.svg": [
		16058,
		9,
		16058
	],
	"./clientsNew/TBank.svg": [
		77173,
		9,
		77173
	],
	"./clientsNew/TOKO.svg": [
		30099,
		9,
		30099
	],
	"./clientsNew/Taiwan.svg": [
		39989,
		9,
		39989
	],
	"./clientsNew/USDT.svg": [
		56628,
		9,
		56628
	],
	"./clientsNew/USdata.svg": [
		86782,
		9,
		86782
	],
	"./clientsNew/WowTech.svg": [
		27342,
		9,
		27342
	],
	"./clientsNew/YGGJ.svg": [
		21977,
		9,
		21977
	],
	"./clientsNew/bincentive.svg": [
		83307,
		9,
		83307
	],
	"./clientsNew/invention.svg": [
		90559,
		9,
		90559
	],
	"./clientsNew/megaBank.svg": [
		90818,
		9,
		90818
	],
	"./compliance/AdverseMedia.svg": [
		63744,
		9,
		63744
	],
	"./compliance/AuditFlow.png": [
		35947,
		9,
		35947
	],
	"./compliance/AuditFlow.webp": [
		64049,
		9,
		64049
	],
	"./compliance/AuditReport.webp": [
		78107,
		9,
		78107
	],
	"./compliance/GlobalBlacklists.svg": [
		64601,
		9,
		64601
	],
	"./compliance/KYA.svg": [
		63752,
		9,
		63752
	],
	"./compliance/KYB.svg": [
		40717,
		9,
		40717
	],
	"./compliance/KYC.svg": [
		59661,
		9,
		59661
	],
	"./compliance/Main-1.webp": [
		97654,
		9,
		97654
	],
	"./compliance/Main-2.webp": [
		88416,
		9,
		88416
	],
	"./compliance/Main-3.webp": [
		60758,
		9,
		60758
	],
	"./compliance/Main.webp": [
		50449,
		9,
		50449
	],
	"./compliance/Main2.webp": [
		50146,
		9,
		50146
	],
	"./compliance/PEPRCAList.svg": [
		64020,
		9,
		64020
	],
	"./compliance/SanctionList.svg": [
		49647,
		9,
		49647
	],
	"./compliance/SearchEngine.webp": [
		42855,
		9,
		42855
	],
	"./compliance/apg.png": [
		52458,
		9,
		52458
	],
	"./compliance/apg.webp": [
		45804,
		9,
		45804
	],
	"./compliance/dj-1.webp": [
		57061,
		9,
		57061
	],
	"./compliance/dj-2.webp": [
		66552,
		9,
		66552
	],
	"./compliance/dj-3.webp": [
		79803,
		9,
		79803
	],
	"./compliance/dj-4.webp": [
		65945,
		9,
		65945
	],
	"./compliance/dj-5.webp": [
		4821,
		9,
		4821
	],
	"./compliance/dj-6.webp": [
		66543,
		9,
		66543
	],
	"./compliance/ekyc-1.webp": [
		55960,
		9,
		55960
	],
	"./compliance/ekyc-2.webp": [
		11647,
		9,
		11647
	],
	"./compliance/ekyc-3.webp": [
		86845,
		9,
		86845
	],
	"./compliance/ekyc-4.webp": [
		44012,
		9,
		44012
	],
	"./compliance/ekyc-5.webp": [
		58164,
		9,
		58164
	],
	"./compliance/eu.png": [
		7073,
		9,
		7073
	],
	"./compliance/eu.webp": [
		32471,
		9,
		32471
	],
	"./compliance/fatf.png": [
		88020,
		9
	],
	"./compliance/fatf.webp": [
		89720,
		9,
		89720
	],
	"./compliance/flow/ArrowS.svg": [
		25230,
		9,
		25230
	],
	"./compliance/flow/DJ.svg": [
		30719,
		9,
		30719
	],
	"./compliance/flow/KG.svg": [
		42633,
		9,
		42633
	],
	"./compliance/flow/KGteam.svg": [
		19462,
		9,
		19462
	],
	"./compliance/flow/MobileSDK.svg": [
		49593,
		9,
		49593
	],
	"./compliance/flow/UI.svg": [
		28595,
		9,
		28595
	],
	"./compliance/flow/UI.webp": [
		26824,
		9,
		26824
	],
	"./compliance/flow/WebAPI.svg": [
		95958,
		9,
		95958
	],
	"./compliance/flow/WebSDK.svg": [
		55964,
		9,
		55964
	],
	"./compliance/flow/blockChain.svg": [
		14383,
		9,
		14383
	],
	"./compliance/flow/dataClear.svg": [
		53164,
		9,
		53164
	],
	"./compliance/flow/flow-bk.svg": [
		46249,
		9,
		46249
	],
	"./compliance/flow/flow-dj.svg": [
		92616,
		9,
		92616
	],
	"./compliance/flow/flow-kyc.svg": [
		2830,
		9,
		2830
	],
	"./compliance/flow/jumio.svg": [
		62327,
		9,
		62327
	],
	"./compliance/flow/list.svg": [
		88081,
		9,
		88081
	],
	"./compliance/flow/update.svg": [
		12014,
		9,
		12014
	],
	"./compliance/hmt.png": [
		31471,
		9,
		31471
	],
	"./compliance/hmt.webp": [
		86905,
		9,
		86905
	],
	"./compliance/iso27001.png": [
		26804,
		9
	],
	"./compliance/iso27701.png": [
		98707,
		9
	],
	"./compliance/ofac.png": [
		71475,
		9
	],
	"./compliance/ofac.webp": [
		62547,
		9,
		62547
	],
	"./compliance/soc2.png": [
		65516,
		9
	],
	"./compliance/vasp.png": [
		16944,
		9
	],
	"./contactUs/check.svg": [
		57693,
		9
	],
	"./download-Apk.png": [
		14810,
		9,
		14810
	],
	"./download-android.png": [
		26455,
		9,
		26455
	],
	"./download-ios.png": [
		94258,
		9,
		94258
	],
	"./error.svg": [
		27283,
		9,
		27283
	],
	"./fav.png": [
		37941,
		9,
		37941
	],
	"./favicon.png": [
		53883,
		9,
		53883
	],
	"./featureWallet/appCreative.style": [
		48934,
		9,
		48934
	],
	"./featureWallet/appCreative.style.js": [
		48934,
		9,
		48934
	],
	"./homepage/91AppCelement.png": [
		81294,
		9,
		81294
	],
	"./homepage/AccupassTiffany.png": [
		42805,
		9,
		42805
	],
	"./homepage/BAVEAvery.png": [
		23930,
		9,
		23930
	],
	"./homepage/Banner0.webp": [
		65018,
		9,
		65018
	],
	"./homepage/Banner0iPad.webp": [
		36008,
		9,
		36008
	],
	"./homepage/Banner0iPhone.avif": [
		6592,
		9,
		6592
	],
	"./homepage/Banner1.webp": [
		58418,
		9,
		58418
	],
	"./homepage/Banner1iPad.webp": [
		29879,
		9,
		29879
	],
	"./homepage/Banner1iPhone.avif": [
		61808,
		9,
		61808
	],
	"./homepage/Banner2.webp": [
		21252,
		9,
		21252
	],
	"./homepage/Banner2iPad.webp": [
		36356,
		9,
		36356
	],
	"./homepage/Banner2iPhone.avif": [
		97612,
		9,
		97612
	],
	"./homepage/FansiTK.png": [
		81883,
		9,
		81883
	],
	"./homepage/HOYABITZoe.png": [
		46825,
		9,
		46825
	],
	"./homepage/MClubEdison.png": [
		13395,
		9,
		13395
	],
	"./homepage/Megabank.png": [
		99419,
		9,
		99419
	],
	"./homepage/OursongPoChang.png": [
		52752,
		9,
		52752
	],
	"./homepage/Studio.webp": [
		88782,
		9,
		88782
	],
	"./homepage/TABEIHank.png": [
		32912,
		9,
		32912
	],
	"./homepage/TAGJoe.png": [
		538,
		9,
		538
	],
	"./homepage/YGGJZed.png": [
		62297,
		9,
		62297
	],
	"./interior/about_parent.png": [
		81546,
		9
	],
	"./interior/curv-bg.svg": [
		95997,
		9,
		95997
	],
	"./interior/feature/1.svg": [
		50627,
		9
	],
	"./interior/feature/2.svg": [
		46894,
		9
	],
	"./interior/feature/3.svg": [
		67059,
		9
	],
	"./interior/footer-curv.svg": [
		27111,
		9,
		27111
	],
	"./interior/gallery/1.jpg": [
		89151,
		9
	],
	"./interior/gallery/2.jpg": [
		65324,
		9
	],
	"./interior/gallery/3.jpg": [
		61605,
		9
	],
	"./interior/gallery/4.jpg": [
		7117,
		9
	],
	"./interior/gallery/5.jpg": [
		56623,
		9
	],
	"./interior/google-icon.jpg": [
		15963,
		9,
		15963
	],
	"./interior/grid.svg": [
		72821,
		9,
		72821
	],
	"./interior/login-bg.jpg": [
		4251,
		9,
		4251
	],
	"./interior/logo.png": [
		56785,
		9,
		56785
	],
	"./interior/logo.svg": [
		97171,
		9,
		97171
	],
	"./interior/map.png": [
		29153,
		9,
		29153
	],
	"./interior/projects/1.png": [
		9620,
		9
	],
	"./interior/projects/s1.png": [
		81494,
		9,
		81494
	],
	"./interior/slider/slide-1.png": [
		81523,
		9
	],
	"./interior/slider/slide-2.png": [
		32644,
		9
	],
	"./interior/slider/slide-3.png": [
		50503,
		9
	],
	"./interior/team/member1.jpg": [
		22893,
		9
	],
	"./interior/team/member2.jpg": [
		30901,
		9
	],
	"./interior/team/member3.jpg": [
		30535,
		9
	],
	"./interior/twitter.svg": [
		81573,
		9,
		81573
	],
	"./joinUs/Accountability.svg": [
		73552,
		9,
		73552
	],
	"./joinUs/GrowthMindset.svg": [
		94847,
		9,
		94847
	],
	"./joinUs/Integrity.svg": [
		56165,
		9,
		56165
	],
	"./joinUs/benefits/equipment.svg": [
		62069,
		9,
		62069
	],
	"./joinUs/benefits/events.svg": [
		24559,
		9,
		24559
	],
	"./joinUs/benefits/salary.svg": [
		59098,
		9,
		59098
	],
	"./key_feature/1.svg": [
		88557,
		9
	],
	"./key_feature/2.svg": [
		16200,
		9
	],
	"./key_feature/3.svg": [
		48777,
		9
	],
	"./key_feature/4.svg": [
		64502,
		9
	],
	"./logo-white.svg": [
		31487,
		9,
		31487
	],
	"./logo.svg": [
		88463,
		9
	],
	"./lucky-bag-2023/BottomImage-1920.png": [
		37263,
		9,
		37263
	],
	"./lucky-bag-2023/BottomImage-768.png": [
		18347,
		9,
		18347
	],
	"./lucky-bag-2023/Demi.jpg": [
		14724,
		9,
		14724
	],
	"./lucky-bag-2023/Download-Apk.png": [
		70955,
		9,
		70955
	],
	"./lucky-bag-2023/Download-AppStore.png": [
		43092,
		9,
		43092
	],
	"./lucky-bag-2023/Download-GooglePlay.png": [
		22071,
		9,
		22071
	],
	"./lucky-bag-2023/KGX91APP.svg": [
		6659,
		9,
		6659
	],
	"./lucky-bag-2023/KGX91APP.webp": [
		91267,
		9,
		91267
	],
	"./lucky-bag-2023/KryptoGO.jpg": [
		17936,
		9,
		17936
	],
	"./lucky-bag-2023/LOGOWhite.svg": [
		55614,
		9,
		55614
	],
	"./lucky-bag-2023/Logo-Demi.png": [
		65175,
		9,
		65175
	],
	"./lucky-bag-2023/Logo-KryptoGO.png": [
		67620,
		9,
		67620
	],
	"./lucky-bag-2023/Logo-icon.png": [
		27706,
		9,
		27706
	],
	"./lucky-bag-2023/LogoWrapper.png": [
		60104,
		9,
		60104
	],
	"./lucky-bag-2023/Share-button-W.svg": [
		72120,
		9,
		72120
	],
	"./lucky-bag-2023/TopImage-1920.png": [
		71962,
		9,
		71962
	],
	"./lucky-bag-2023/TopImage-768.png": [
		64274,
		9,
		64274
	],
	"./lucky-bag-2023/WalletConnectModal": [
		52655,
		9,
		70674,
		50736
	],
	"./lucky-bag-2023/WalletConnectModal.js": [
		52655,
		9,
		70674,
		50736
	],
	"./lucky-bag-2023/banners/banner1.webp": [
		16240,
		9,
		16240
	],
	"./lucky-bag-2023/bg/bg1.svg": [
		63313,
		9,
		63313
	],
	"./lucky-bag-2023/bg/bg2.svg": [
		41128,
		9,
		41128
	],
	"./lucky-bag-2023/bonus/Bonus1.webp": [
		83734,
		9,
		83734
	],
	"./lucky-bag-2023/bonus/Bonus2.webp": [
		21889,
		9,
		21889
	],
	"./lucky-bag-2023/bonus/airpods.webp": [
		73962,
		9,
		73962
	],
	"./lucky-bag-2023/bonus/ipad.webp": [
		75605,
		9,
		75605
	],
	"./lucky-bag-2023/bonus/iphone.webp": [
		40033,
		9,
		40033
	],
	"./lucky-bag-2023/bonus/ps5.webp": [
		69620,
		9,
		69620
	],
	"./lucky-bag-2023/bonus/tv.webp": [
		85490,
		9,
		85490
	],
	"./lucky-bag-2023/bonus/watch.webp": [
		77797,
		9,
		77797
	],
	"./lucky-bag-2023/button-DeepLink-W.svg": [
		8611,
		9,
		8611
	],
	"./lucky-bag-2023/button-Share-W.svg": [
		97336,
		9,
		97336
	],
	"./lucky-bag-2023/dc-.png": [
		48414,
		9,
		48414
	],
	"./lucky-bag-2023/dc.png": [
		93593,
		9,
		93593
	],
	"./lucky-bag-2023/decorations/NFTBox.svg": [
		99566,
		9,
		99566
	],
	"./lucky-bag-2023/decorations/ball.svg": [
		73556,
		9,
		73556
	],
	"./lucky-bag-2023/decorations/balloonB.svg": [
		15748,
		9,
		15748
	],
	"./lucky-bag-2023/decorations/balloonG.svg": [
		29683,
		9,
		29683
	],
	"./lucky-bag-2023/decorations/balloonR.svg": [
		86102,
		9,
		86102
	],
	"./lucky-bag-2023/decorations/balloonY.svg": [
		46501,
		9,
		46501
	],
	"./lucky-bag-2023/decorations/balloonYG.svg": [
		15499,
		9,
		15499
	],
	"./lucky-bag-2023/decorations/blob1.svg": [
		25129,
		9,
		25129
	],
	"./lucky-bag-2023/decorations/blob2.svg": [
		49412,
		9,
		49412
	],
	"./lucky-bag-2023/decorations/decorateG.svg": [
		29050,
		9,
		29050
	],
	"./lucky-bag-2023/decorations/decorateW.svg": [
		67458,
		9,
		67458
	],
	"./lucky-bag-2023/decorations/dinosaur.svg": [
		51853,
		9,
		51853
	],
	"./lucky-bag-2023/decorations/earth.svg": [
		19487,
		9,
		19487
	],
	"./lucky-bag-2023/decorations/flowerP.svg": [
		53146,
		9,
		53146
	],
	"./lucky-bag-2023/decorations/flowerR.svg": [
		76334,
		9,
		76334
	],
	"./lucky-bag-2023/decorations/planetB.svg": [
		2465,
		9,
		2465
	],
	"./lucky-bag-2023/decorations/planetR.svg": [
		23571,
		9,
		23571
	],
	"./lucky-bag-2023/decorations/rainbow.svg": [
		15272,
		9,
		15272
	],
	"./lucky-bag-2023/decorations/ribbon.svg": [
		94101,
		9,
		94101
	],
	"./lucky-bag-2023/decorations/rocket.svg": [
		408,
		9,
		408
	],
	"./lucky-bag-2023/decorations/starW.svg": [
		2329,
		9,
		2329
	],
	"./lucky-bag-2023/decorations/starY.svg": [
		34440,
		9,
		34440
	],
	"./lucky-bag-2023/decorationsNew/Arrow.svg": [
		73289,
		9,
		73289
	],
	"./lucky-bag-2023/decorationsNew/NFTBOX.webp": [
		11057,
		9,
		11057
	],
	"./lucky-bag-2023/decorationsNew/Q1.svg": [
		54985,
		9,
		54985
	],
	"./lucky-bag-2023/decorationsNew/Q2.svg": [
		54003,
		9,
		54003
	],
	"./lucky-bag-2023/decorationsNew/Star BG.svg": [
		43307,
		9,
		43307
	],
	"./lucky-bag-2023/decorationsNew/StarBG.svg": [
		94898,
		9,
		94898
	],
	"./lucky-bag-2023/decorationsNew/StarS color.svg": [
		37820,
		9,
		37820
	],
	"./lucky-bag-2023/decorationsNew/StarS white.svg": [
		4962,
		9,
		4962
	],
	"./lucky-bag-2023/decorationsNew/blob1.svg": [
		18888,
		9,
		18888
	],
	"./lucky-bag-2023/decorationsNew/blob2.svg": [
		49272,
		9,
		49272
	],
	"./lucky-bag-2023/decorationsNew/blobman3.svg": [
		96213,
		9,
		96213
	],
	"./lucky-bag-2023/decorationsNew/blobmannoeye.svg": [
		33489,
		9,
		33489
	],
	"./lucky-bag-2023/decorationsNew/circle.svg": [
		36210,
		9,
		36210
	],
	"./lucky-bag-2023/decorationsNew/iphone.webp": [
		86923,
		9,
		86923
	],
	"./lucky-bag-2023/decorationsNew/smallcircle.svg": [
		41192,
		9,
		41192
	],
	"./lucky-bag-2023/decorationsNew/starMask.svg": [
		80704,
		9,
		80704
	],
	"./lucky-bag-2023/demo/awards.webp": [
		99049,
		9,
		99049
	],
	"./lucky-bag-2023/demo/bonus.webp": [
		47471,
		9,
		47471
	],
	"./lucky-bag-2023/demo/bouns.webp": [
		27148,
		9,
		27148
	],
	"./lucky-bag-2023/demo/footer.webp": [
		65663,
		9,
		65663
	],
	"./lucky-bag-2023/demo/hero.webp": [
		63267,
		9,
		63267
	],
	"./lucky-bag-2023/demo/info.webp": [
		36006,
		9,
		36006
	],
	"./lucky-bag-2023/demo/partner1.webp": [
		42749,
		9,
		42749
	],
	"./lucky-bag-2023/demo/partner2.webp": [
		42146,
		9,
		42146
	],
	"./lucky-bag-2023/demo/partner3.webp": [
		49958,
		9,
		49958
	],
	"./lucky-bag-2023/demo/rewards.webp": [
		67318,
		9,
		67318
	],
	"./lucky-bag-2023/dog-main.svg": [
		69685,
		9,
		69685
	],
	"./lucky-bag-2023/dog1.svg": [
		24946,
		9,
		24946
	],
	"./lucky-bag-2023/dog1.webp": [
		29275,
		9,
		29275
	],
	"./lucky-bag-2023/dog2.svg": [
		2503,
		9,
		2503
	],
	"./lucky-bag-2023/dog2.webp": [
		25042,
		9,
		25042
	],
	"./lucky-bag-2023/faq/connect1.jpg": [
		2434,
		9,
		2434
	],
	"./lucky-bag-2023/faq/connect2.jpg": [
		13054,
		9,
		13054
	],
	"./lucky-bag-2023/faq/mint1.jpg": [
		33503,
		9,
		33503
	],
	"./lucky-bag-2023/faq/nft-redeem-online1.jpg": [
		61783,
		9,
		61783
	],
	"./lucky-bag-2023/faq/nft-redeem-online2.jpg": [
		10885,
		9,
		10885
	],
	"./lucky-bag-2023/faq/nft-redeem.jpg": [
		31982,
		9,
		31982
	],
	"./lucky-bag-2023/faq/nft-view.jpg": [
		55636,
		9,
		55636
	],
	"./lucky-bag-2023/faq/proccess1.jpeg": [
		79811,
		9,
		79811
	],
	"./lucky-bag-2023/faq/proccess2.jpeg": [
		49488,
		9,
		49488
	],
	"./lucky-bag-2023/faq/proccess3.jpeg": [
		76504,
		9,
		76504
	],
	"./lucky-bag-2023/icon-blue.png": [
		30335,
		9,
		30335
	],
	"./lucky-bag-2023/icon-white.png": [
		95091,
		9,
		95091
	],
	"./lucky-bag-2023/icon-yellow.png": [
		33670,
		9,
		33670
	],
	"./lucky-bag-2023/icon/Discord.svg": [
		79943,
		9,
		79943
	],
	"./lucky-bag-2023/icon/FB.svg": [
		86367,
		9,
		86367
	],
	"./lucky-bag-2023/icon/Link.svg": [
		91989,
		9,
		91989
	],
	"./lucky-bag-2023/icon/Web.svg": [
		32280,
		9,
		32280
	],
	"./lucky-bag-2023/info1.webp": [
		44252,
		9,
		44252
	],
	"./lucky-bag-2023/info2.webp": [
		44154,
		9,
		44154
	],
	"./lucky-bag-2023/info3.webp": [
		50987,
		9,
		50987
	],
	"./lucky-bag-2023/info4.webp": [
		18550,
		9,
		18550
	],
	"./lucky-bag-2023/logos/beast.webp": [
		82111,
		9,
		82111
	],
	"./lucky-bag-2023/logos/beastRect.webp": [
		35835,
		9,
		35835
	],
	"./lucky-bag-2023/logos/domhie.webp": [
		40500,
		9,
		40500
	],
	"./lucky-bag-2023/logos/domhieRect.webp": [
		25866,
		9,
		25866
	],
	"./lucky-bag-2023/logos/kuaicher.webp": [
		75304,
		9,
		75304
	],
	"./lucky-bag-2023/logos/kuaicherRect.webp": [
		365,
		9,
		365
	],
	"./lucky-bag-2023/logos/norns.webp": [
		31617,
		9,
		31617
	],
	"./lucky-bag-2023/logos/nornsRect.webp": [
		1207,
		9,
		1207
	],
	"./lucky-bag-2023/logos/ok.webp": [
		72776,
		9,
		72776
	],
	"./lucky-bag-2023/logos/okRect.webp": [
		23849,
		9,
		23849
	],
	"./lucky-bag-2023/ogimage.jpg": [
		65922,
		9,
		65922
	],
	"./lucky-bag-2023/partner/KGBanner.webp": [
		39135,
		9,
		39135
	],
	"./lucky-bag-2023/partner/Kuaicher.webp": [
		58358,
		9,
		58358
	],
	"./lucky-bag-2023/partner/KuaicherR.webp": [
		20448,
		9,
		20448
	],
	"./lucky-bag-2023/partner/Norns.webp": [
		63728,
		9,
		63728
	],
	"./lucky-bag-2023/partner/NornsR.webp": [
		44208,
		9,
		44208
	],
	"./lucky-bag-2023/partner/beast.webp": [
		15070,
		9,
		15070
	],
	"./lucky-bag-2023/partner/beastR.webp": [
		10915,
		9,
		10915
	],
	"./lucky-bag-2023/partner/domhie.webp": [
		59782,
		9,
		59782
	],
	"./lucky-bag-2023/partner/domhieR.webp": [
		47080,
		9,
		47080
	],
	"./lucky-bag-2023/partner/ok.webp": [
		16112,
		9,
		16112
	],
	"./lucky-bag-2023/partner/okR.webp": [
		83010,
		9,
		24124
	],
	"./lucky-bag-2023/partner/test.png": [
		85053,
		9,
		85053
	],
	"./lucky-bag-2023/prize-coffee.png": [
		68112,
		9,
		68112
	],
	"./lucky-bag-2023/prize-hotel.png": [
		16287,
		9,
		16287
	],
	"./lucky-bag-2023/prize-ipad.png": [
		65023,
		9,
		65023
	],
	"./lucky-bag-2023/prize-resturant.png": [
		60148,
		9,
		60148
	],
	"./lucky-bag-2023/prize/Chalicha.png": [
		19921,
		9,
		19921
	],
	"./lucky-bag-2023/prize/HWC.jpg": [
		11296,
		9,
		11296
	],
	"./lucky-bag-2023/prize/Kaidon.png": [
		64674,
		9,
		64674
	],
	"./lucky-bag-2023/prize/RAW.jpg": [
		34976,
		9,
		34976
	],
	"./lucky-bag-2023/prize/RAW.png": [
		36294,
		9,
		36294
	],
	"./lucky-bag-2023/prize/TheLalu.jpg": [
		70807,
		9,
		70807
	],
	"./lucky-bag-2023/prize/TheLalu.png": [
		58718,
		9,
		58718
	],
	"./lucky-bag-2023/prize/demi-human-9284.jpg": [
		24902,
		9,
		24902
	],
	"./lucky-bag-2023/prize/hala-chicken.png": [
		91231,
		9,
		91231
	],
	"./lucky-bag-2023/prize/hwc.jpeg": [
		8274,
		9,
		8274
	],
	"./lucky-bag-2023/prize/iPadMini.jpg": [
		40262,
		9,
		40262
	],
	"./lucky-bag-2023/prize/iPadMini.png": [
		25597,
		9,
		25597
	],
	"./lucky-bag-2023/prize/iShare.png": [
		74031,
		9,
		74031
	],
	"./lucky-bag-2023/prize/naughty-lady.jpeg": [
		20070,
		9,
		20070
	],
	"./lucky-bag-2023/shop/Pic-1.jpg": [
		57187,
		9,
		57187
	],
	"./lucky-bag-2023/shop/Pic-2.jpg": [
		29260,
		9,
		29260
	],
	"./lucky-bag-2023/shop/Pic-3.jpg": [
		57784,
		9,
		57784
	],
	"./lucky-bag-2023/shop/Pic-4.jpg": [
		10797,
		9,
		10797
	],
	"./lucky-bag-2023/shop/Pic-5.jpg": [
		47146,
		9,
		47146
	],
	"./lucky-bag-2023/shop/Pic.jpg": [
		22966,
		9,
		22966
	],
	"./lucky-bag-2023/shop/pic01.jpg": [
		54277,
		9,
		54277
	],
	"./lucky-bag-2023/shop/pic02.jpg": [
		78594,
		9,
		78594
	],
	"./lucky-bag-2023/shop/pic03.jpg": [
		57652,
		9,
		57652
	],
	"./lucky-bag-2023/shop/pic04.jpg": [
		9172,
		9,
		9172
	],
	"./lucky-bag-2023/shop/pic05.jpg": [
		76774,
		9,
		76774
	],
	"./lucky-bag-2023/shop/pic06.jpg": [
		79346,
		9,
		79346
	],
	"./lucky-bag-2023/shop/pic07.jpg": [
		90274,
		9,
		90274
	],
	"./lucky-bag-2023/shop/pic08.jpg": [
		33278,
		9,
		33278
	],
	"./lucky-bag-2023/shop/pic09.jpg": [
		61705,
		9,
		61705
	],
	"./lucky-bag-2023/shop/pic10.jpg": [
		62916,
		9,
		62916
	],
	"./lucky-bag-2023/shop/pic11.jpg": [
		83618,
		9,
		83618
	],
	"./lucky-bag-2023/shop/pic12.jpg": [
		89826,
		9,
		89826
	],
	"./lucky-bag-2023/shop/pic13.jpg": [
		42922,
		9,
		42922
	],
	"./lucky-bag-2023/shop/pic14.jpg": [
		27949,
		9,
		27949
	],
	"./lucky-bag-2023/shop/pic15.jpg": [
		28347,
		9,
		28347
	],
	"./lucky-bag-2023/shop/pic16.jpg": [
		83339,
		9,
		83339
	],
	"./lucky-bag-2023/shop/pic17.jpg": [
		72144,
		9,
		72144
	],
	"./lucky-bag-2023/shop/pic18.jpg": [
		85806,
		9,
		85806
	],
	"./lucky-bag-2023/shop/pic19.jpg": [
		69023,
		9,
		69023
	],
	"./lucky-bag-2023/shop/pic20.jpg": [
		51343,
		9,
		51343
	],
	"./lucky-bag-2023/shop/pic21.jpg": [
		7739,
		9,
		7739
	],
	"./lucky-bag-2023/shop/pic22.jpg": [
		86138,
		9,
		86138
	],
	"./lucky-bag-2023/shop/pic23.jpg": [
		40604,
		9,
		40604
	],
	"./lucky-bag-2023/shop/pic24.jpg": [
		31426,
		9,
		31426
	],
	"./lucky-bag-2023/shop/pic25.jpg": [
		56693,
		9,
		56693
	],
	"./lucky-bag-2023/shop/pic26.jpg": [
		8281,
		9,
		8281
	],
	"./lucky-bag-2023/shop/pic27.jpg": [
		31740,
		9,
		31740
	],
	"./lucky-bag-2023/shop/pic28.jpg": [
		87503,
		9,
		87503
	],
	"./lucky-bag-2023/shop/pic29.jpg": [
		7385,
		9,
		7385
	],
	"./lucky-bag-2023/shop/pic30.jpg": [
		947,
		9,
		947
	],
	"./lucky-bag-2023/shop/pic31.jpg": [
		37592,
		9,
		37592
	],
	"./lucky-bag-2023/shop/pic32.jpg": [
		3343,
		9,
		3343
	],
	"./lucky-bag-2023/shop/pic33.jpg": [
		53193,
		9,
		53193
	],
	"./lucky-bag-2023/shop/pic34.jpg": [
		939,
		9,
		939
	],
	"./lucky-bag-2023/shop/pic35.jpg": [
		39604,
		9,
		39604
	],
	"./lucky-bag-2023/shop/pic36.jpg": [
		1979,
		9,
		1979
	],
	"./lucky-bag-2023/shop/pic37.jpg": [
		9154,
		9,
		9154
	],
	"./lucky-bag-2023/shop/pic38.jpg": [
		53572,
		9,
		53572
	],
	"./lucky-bag-2023/shop/pic39.jpg": [
		28208,
		9,
		28208
	],
	"./lucky-bag-2023/shop/pic40.jpg": [
		47005,
		9,
		47005
	],
	"./lucky-bag-2023/shop/pic41.jpg": [
		81420,
		9,
		81420
	],
	"./lucky-bag-2023/shop/pic42.jpg": [
		20190,
		9,
		20190
	],
	"./lucky-bag-2023/shop/pic43.jpg": [
		17411,
		9,
		17411
	],
	"./lucky-bag-2023/shop/pic44.jpg": [
		58230,
		9,
		58230
	],
	"./lucky-bag-2023/shop/pic45.jpg": [
		91192,
		9,
		91192
	],
	"./lucky-bag-2023/tabs/luckybaglogo1.svg": [
		12421,
		9,
		12421
	],
	"./lucky-bag-2023/tabs/luckybaglogo2.svg": [
		17486,
		9,
		17486
	],
	"./lucky-bag-2023/tabs/luckybaglogo3.svg": [
		55978,
		9,
		55978
	],
	"./lucky-bag-2023/tabs/luckybaglogo4.svg": [
		55145,
		9,
		55145
	],
	"./lucky-bag-2023/tabs/luckybaglogo5.svg": [
		57852,
		9,
		57852
	],
	"./lucky-bag-2023/tabs/luckybaglogo6.svg": [
		37510,
		9,
		37510
	],
	"./lucky-bag-2023/team-demi.png": [
		17333,
		9,
		17333
	],
	"./lucky-bag-2023/team-kg.png": [
		84031,
		9,
		84031
	],
	"./lucky-bag-2023/tiger-1.png": [
		10950,
		9,
		10950
	],
	"./lucky-bag-2023/tiger-2.png": [
		51559,
		9,
		51559
	],
	"./lucky-bag-2023/tiger-3.png": [
		31937,
		9,
		31937
	],
	"./lucky-bag-2023/tiger-rwd-01.png": [
		70449,
		9,
		70449
	],
	"./lucky-bag-2023/tiger-rwd-02.png": [
		37120,
		9,
		37120
	],
	"./lucky-bag-2023/tiger-rwd-03.png": [
		88801,
		9,
		88801
	],
	"./lucky-bag-2023/tiger.png": [
		34167,
		9,
		34167
	],
	"./lucky-bag-2023/user-manual.png": [
		30582,
		9,
		30582
	],
	"./lucky-bag-2023/web-link-.png": [
		5963,
		9,
		5963
	],
	"./lucky-bag-2023/web-link.png": [
		49838,
		9,
		49838
	],
	"./moneyFortune/BlueLOGO.svg": [
		39791,
		9,
		39791
	],
	"./moneyFortune/Download-AppStore.svg": [
		46463,
		9,
		46463
	],
	"./moneyFortune/Download-DeepLink.svg": [
		6642,
		9,
		6642
	],
	"./moneyFortune/Download-GooglePlay.svg": [
		58930,
		9,
		58930
	],
	"./moneyFortune/QAimage/image1.webp": [
		34283,
		9,
		34283
	],
	"./moneyFortune/QAimage/image2.webp": [
		92038,
		9,
		92038
	],
	"./moneyFortune/QAimage/image3.webp": [
		5151,
		9,
		5151
	],
	"./moneyFortune/QAimage/image4.webp": [
		23060,
		9,
		23060
	],
	"./moneyFortune/QAimage/image5.webp": [
		85374,
		9,
		85374
	],
	"./moneyFortune/Role/ARK.webp": [
		85931,
		9,
		85931
	],
	"./moneyFortune/Role/Amber.webp": [
		80141,
		9,
		80141
	],
	"./moneyFortune/Role/DoKwon.webp": [
		14775,
		9,
		14775
	],
	"./moneyFortune/Role/JiuCai.webp": [
		54630,
		9,
		54630
	],
	"./moneyFortune/Role/Kordan.webp": [
		53461,
		9,
		53461
	],
	"./moneyFortune/Role/LaoZi.webp": [
		15014,
		9,
		15014
	],
	"./moneyFortune/Role/MaJi.webp": [
		89352,
		9,
		49556
	],
	"./moneyFortune/Role/Musk.webp": [
		74359,
		9,
		74359
	],
	"./moneyFortune/Role/Rothschild.webp": [
		92168,
		9,
		92168
	],
	"./moneyFortune/Role/V.webp": [
		78685,
		9,
		78685
	],
	"./moneyFortune/Role/ZongBenCong.webp": [
		57454,
		9,
		57454
	],
	"./moneyFortune/ShareButton.svg": [
		82462,
		9,
		82462
	],
	"./moneyFortune/circles/Circle1.svg": [
		24578,
		9,
		24578
	],
	"./moneyFortune/circles/Circle2.svg": [
		29015,
		9,
		29015
	],
	"./moneyFortune/circles/Circle3.svg": [
		99069,
		9,
		99069
	],
	"./moneyFortune/circles/Circle4.svg": [
		89432,
		9,
		89432
	],
	"./moneyFortune/first-floor.webp": [
		39809,
		9,
		39809
	],
	"./moneyFortune/person.webp": [
		88069,
		9,
		88069
	],
	"./moneyFortune/resultRoleImgs/share-ARK.webp": [
		75907,
		9,
		75907
	],
	"./moneyFortune/resultRoleImgs/share-Amber.webp": [
		16815,
		9,
		16815
	],
	"./moneyFortune/resultRoleImgs/share-DoKwon.webp": [
		95589,
		9,
		95589
	],
	"./moneyFortune/resultRoleImgs/share-JiuCai.webp": [
		54818,
		9,
		54818
	],
	"./moneyFortune/resultRoleImgs/share-Kordan.webp": [
		74318,
		9,
		74318
	],
	"./moneyFortune/resultRoleImgs/share-LaoZi.webp": [
		62726,
		9,
		62726
	],
	"./moneyFortune/resultRoleImgs/share-MaJi.webp": [
		76225,
		9,
		76225
	],
	"./moneyFortune/resultRoleImgs/share-Musk.webp": [
		96521,
		9,
		96521
	],
	"./moneyFortune/resultRoleImgs/share-Rothschild.webp": [
		59584,
		9,
		59584
	],
	"./moneyFortune/resultRoleImgs/share-V.webp": [
		44833,
		9,
		44833
	],
	"./moneyFortune/resultRoleImgs/share-ZongBenCong.webp": [
		12074,
		9,
		12074
	],
	"./moneyFortune/second-floor/KGLOGO.webp": [
		79631,
		9,
		79631
	],
	"./moneyFortune/second-floor/NFT01.webp": [
		70286,
		9,
		70286
	],
	"./moneyFortune/second-floor/NFT02.webp": [
		78184,
		9,
		78184
	],
	"./moneyFortune/second-floor/building.webp": [
		83608,
		9,
		83608
	],
	"./moneyFortune/second-floor/signboard-1.webp": [
		10415,
		9,
		10415
	],
	"./moneyFortune/second-floor/signboard-2.webp": [
		28291,
		9,
		28291
	],
	"./moneyFortune/web3Plus/QABG.webp": [
		89738,
		9,
		89738
	],
	"./moneyFortune/web3Plus/ball.webp": [
		98637,
		9,
		98637
	],
	"./moneyFortune/web3Plus/main_bg.webp": [
		62838,
		9,
		62838
	],
	"./moneyFortune/web3Plus/resultImg/A.webp": [
		23901,
		9,
		23901
	],
	"./moneyFortune/web3Plus/resultImg/AM.webp": [
		33,
		9,
		33
	],
	"./moneyFortune/web3Plus/resultImg/B.webp": [
		76183,
		9,
		76183
	],
	"./moneyFortune/web3Plus/resultImg/BM.webp": [
		61595,
		9,
		61595
	],
	"./moneyFortune/web3Plus/resultImg/C.webp": [
		60105,
		9,
		60105
	],
	"./moneyFortune/web3Plus/resultImg/CM.webp": [
		66396,
		9,
		66396
	],
	"./moneyFortune/web3Plus/resultImg/D.webp": [
		45061,
		9,
		45061
	],
	"./moneyFortune/web3Plus/resultImg/DM.webp": [
		42395,
		9,
		42395
	],
	"./moneyFortune/web3Plus/resultImg/E.webp": [
		45591,
		9,
		45591
	],
	"./moneyFortune/web3Plus/resultImg/EM.webp": [
		21931,
		9,
		21931
	],
	"./moneyFortune/web3Plus/resultball.webp": [
		84812,
		9,
		84812
	],
	"./moneyFortune/web3Plus/web3LOGO.svg": [
		61001,
		9,
		61001
	],
	"./new/logo.svg": [
		80802,
		9
	],
	"./partners/gch.svg": [
		3717,
		9,
		3717
	],
	"./partners/mmxtion.svg": [
		17128,
		9,
		17128
	],
	"./partners/moralis.svg": [
		90214,
		9,
		90214
	],
	"./partners/webcomm.svg": [
		58945,
		9,
		58945
	],
	"./products/compliance/api/Banner.webp": [
		3189,
		9
	],
	"./products/compliance/api/KYA.webp": [
		71451,
		9,
		72535
	],
	"./products/compliance/api/KYB.webp": [
		24973,
		9,
		24973
	],
	"./products/compliance/api/KYC.webp": [
		61673,
		9,
		61673
	],
	"./products/compliance/api/Kyabc.webp": [
		92320,
		9,
		92320
	],
	"./products/compliance/complyFlow/Banner": [
		22626,
		3,
		22626
	],
	"./products/compliance/complyFlow/Banner.json": [
		22626,
		3,
		22626
	],
	"./products/compliance/complyFlow/autoKYCAML.webp": [
		69183,
		9,
		69183
	],
	"./products/compliance/complyFlow/dataCollection.webp": [
		93940,
		9,
		93940
	],
	"./products/compliance/complyFlow/digitalize.webp": [
		77051,
		9,
		77051
	],
	"./products/compliance/complyFlow/onboarding.webp": [
		64807,
		9,
		64807
	],
	"./products/compliance/lite/AISummary.png": [
		18540,
		9,
		18540
	],
	"./products/compliance/lite/AISummary.webp": [
		90207,
		9,
		90207
	],
	"./products/compliance/lite/Banner": [
		24089,
		3,
		45215
	],
	"./products/compliance/lite/Banner.json": [
		24089,
		3,
		45215
	],
	"./products/compliance/lite/CMPAssistant.png": [
		78884,
		9,
		78884
	],
	"./products/compliance/lite/CMPAssistant.webp": [
		29857,
		9,
		29857
	],
	"./products/compliance/pro/APG.png": [
		16029,
		9,
		16029
	],
	"./products/compliance/pro/AuditTrail.png": [
		64415,
		9,
		64415
	],
	"./products/compliance/pro/AuditTrail.webp": [
		48327,
		9,
		48327
	],
	"./products/compliance/pro/Banner": [
		65661,
		3,
		65661
	],
	"./products/compliance/pro/Banner.json": [
		65661,
		3,
		65661
	],
	"./products/compliance/pro/CDD.png": [
		68244,
		9,
		9620
	],
	"./products/compliance/pro/FATF.png": [
		72219,
		9,
		72219
	],
	"./products/compliance/pro/HMTreasury.png": [
		38248,
		9,
		38248
	],
	"./products/compliance/pro/IDV.png": [
		70683,
		9,
		70683
	],
	"./products/compliance/pro/IDV.webp": [
		93295,
		9,
		93295
	],
	"./products/compliance/pro/OFAC.png": [
		83004,
		9,
		83004
	],
	"./products/compliance/pro/kya_icon.png": [
		3806,
		9,
		3806
	],
	"./products/compliance/pro/kyb_icon.png": [
		83471,
		9,
		83471
	],
	"./products/compliance/pro/kyc_icon.png": [
		29609,
		9,
		29609
	],
	"./products/icons/AssetProDark.svg": [
		1451,
		9
	],
	"./products/icons/AssetProLight.svg": [
		28407,
		9,
		28407
	],
	"./products/icons/ComplianceAPIDark.svg": [
		91453,
		9
	],
	"./products/icons/ComplianceAPILight.svg": [
		45528,
		9,
		45528
	],
	"./products/icons/ComplianceLight.svg": [
		6043,
		9,
		6043
	],
	"./products/icons/ComplianceLiteDark.svg": [
		24124,
		9
	],
	"./products/icons/ComplianceProDark.svg": [
		23243,
		9
	],
	"./products/icons/ComplianceProLight.svg": [
		90856,
		9,
		90856
	],
	"./products/icons/ComplyFlowDark.svg": [
		99721,
		9
	],
	"./products/icons/ComplyFlowLight.svg": [
		63113,
		9,
		63113
	],
	"./products/icons/NFTAirdropDark.svg": [
		56926,
		9,
		56926
	],
	"./products/icons/NFTAirdropLight.svg": [
		89888,
		9,
		89888
	],
	"./products/icons/NFTBoostDark.svg": [
		47252,
		9
	],
	"./products/icons/NFTBoostLight.svg": [
		63921,
		9,
		38751
	],
	"./products/icons/OAuthSDKDark.svg": [
		60158,
		9
	],
	"./products/icons/OAuthSDKLight.svg": [
		51866,
		9,
		51866
	],
	"./products/icons/TransferDark.svg": [
		44988,
		9
	],
	"./products/icons/TransferLight.svg": [
		40706,
		9,
		40706
	],
	"./products/icons/User360Dark.svg": [
		90981,
		9
	],
	"./products/icons/User360Light.svg": [
		33755,
		9,
		33755
	],
	"./products/icons/WalletAPIDark.svg": [
		1114,
		9
	],
	"./products/icons/WalletAPILight.svg": [
		17097,
		9,
		17097
	],
	"./products/icons/WalletAPPDark.svg": [
		83941,
		9
	],
	"./products/icons/WalletAPPLight.svg": [
		59660,
		9,
		59660
	],
	"./products/icons/WalletApp.svg": [
		55225,
		9,
		55225
	],
	"./products/icons/WalletBuilderDark.svg": [
		42294,
		9
	],
	"./products/icons/WalletBuilderLight.svg": [
		99040,
		9,
		99040
	],
	"./products/icons/WalletExtensionDark.svg": [
		21516,
		9
	],
	"./products/icons/WalletExtensionLight.svg": [
		99427,
		9,
		99427
	],
	"./products/icons/WalletSDKDark.svg": [
		54867,
		9
	],
	"./products/icons/WalletSDKLight.svg": [
		91306,
		9,
		91306
	],
	"./products/icons/style=Transfer, color=Dark.svg": [
		595,
		9,
		595
	],
	"./products/nft/airdrop/Banner": [
		87559,
		3,
		87559
	],
	"./products/nft/airdrop/Banner.json": [
		87559,
		3,
		87559
	],
	"./products/nft/airdrop/Top.svg": [
		44621,
		9,
		44621
	],
	"./products/nft/boost/Banner": [
		91312,
		3,
		91312
	],
	"./products/nft/boost/Banner.json": [
		91312,
		3,
		91312
	],
	"./products/nft/boost/NFTCards.webp": [
		4319,
		9,
		4319
	],
	"./products/onboarding/Banner": [
		86620,
		3,
		86620
	],
	"./products/onboarding/Banner.json": [
		86620,
		3,
		86620
	],
	"./products/onboarding/Cover.svg": [
		46335,
		9,
		46335
	],
	"./products/transfer/Built-in-compliance.png": [
		7984,
		9,
		7984
	],
	"./products/transfer/Cross-border.png": [
		62796,
		9,
		62796
	],
	"./products/transfer/Enterprise-grade-security.png": [
		11526,
		9,
		11526
	],
	"./products/transfer/b2c.png": [
		88120,
		9,
		88120
	],
	"./products/transfer/globe.png": [
		67541,
		9,
		67541
	],
	"./products/transfer/ic-line-check.svg": [
		2043,
		9,
		2043
	],
	"./products/transfer/ic-line-copy.svg": [
		44983,
		9,
		44983
	],
	"./products/transfer/p2p.png": [
		63778,
		9,
		63778
	],
	"./products/user360/Banner": [
		73839,
		3,
		73839
	],
	"./products/user360/Banner.json": [
		73839,
		3,
		73839
	],
	"./products/wallet/api/Banner.webp": [
		61878,
		9
	],
	"./products/wallet/application/AppDownloadAppStore.svg": [
		95531,
		9,
		95531
	],
	"./products/wallet/application/AppDownloadGooglePlay.svg": [
		50672,
		9,
		50672
	],
	"./products/wallet/application/Banner": [
		5887,
		3,
		5887
	],
	"./products/wallet/application/Banner.json": [
		5887,
		3,
		5887
	],
	"./products/wallet/application/Chloe.svg": [
		70973,
		9,
		70973
	],
	"./products/wallet/application/DownloadApp.png": [
		32793,
		9,
		32793
	],
	"./products/wallet/application/DownloadApp.webp": [
		51653,
		9,
		51653
	],
	"./products/wallet/application/Estelle.svg": [
		14575,
		9,
		14575
	],
	"./products/wallet/application/KGwallet1.svg": [
		75500,
		9,
		75500
	],
	"./products/wallet/application/KGwallet2.svg": [
		69220,
		9,
		69220
	],
	"./products/wallet/application/Olivia.svg": [
		64249,
		9,
		64249
	],
	"./products/wallet/application/Safety1.webp": [
		246,
		9,
		246
	],
	"./products/wallet/application/Safety2.webp": [
		64850,
		9,
		64850
	],
	"./products/wallet/application/Safety3.webp": [
		89032,
		9,
		89032
	],
	"./products/wallet/application/Safety4.webp": [
		38138,
		9,
		38138
	],
	"./products/wallet/application/Socialize1.webp": [
		70397,
		9,
		70397
	],
	"./products/wallet/application/Socialize2.webp": [
		18626,
		9,
		18626
	],
	"./products/wallet/application/UX1.webp": [
		21992,
		9,
		21992
	],
	"./products/wallet/application/UX2.webp": [
		32997,
		9,
		32997
	],
	"./products/wallet/application/UX3.webp": [
		52099,
		9,
		52099
	],
	"./products/wallet/application/UX4.webp": [
		98316,
		9,
		98316
	],
	"./products/wallet/application/UX5.webp": [
		77168,
		9,
		77168
	],
	"./products/wallet/assetPro/Banner": [
		74685,
		3,
		74685
	],
	"./products/wallet/assetPro/Banner.json": [
		74685,
		3,
		74685
	],
	"./products/wallet/extension/Banner": [
		23425,
		3,
		23425
	],
	"./products/wallet/extension/Banner.json": [
		23425,
		3,
		23425
	],
	"./products/wallet/sdk/Banner": [
		2077,
		3,
		2077
	],
	"./products/wallet/sdk/Banner.json": [
		2077,
		3,
		2077
	],
	"./products/wallet/sdk/Description.webp": [
		11627,
		9,
		11627
	],
	"./products/wallet/walletBuilder/Banner": [
		42397,
		3,
		42397
	],
	"./products/wallet/walletBuilder/Banner.json": [
		42397,
		3,
		42397
	],
	"./products/wallet/walletBuilder/Swiper1.webp": [
		32335,
		9,
		32335
	],
	"./products/wallet/walletBuilder/Swiper2.webp": [
		4189,
		9,
		4189
	],
	"./products/wallet/walletBuilder/Swiper3.webp": [
		84181,
		9,
		84181
	],
	"./products/wallet/walletBuilder/Swiper4.webp": [
		80291,
		9,
		80291
	],
	"./products/wallet/walletBuilder/Swiper5.webp": [
		13036,
		9,
		13036
	],
	"./products/wallet/walletBuilder/Swiper6.webp": [
		85261,
		9,
		85261
	],
	"./products/wallet/walletBuilder/Swiper7.webp": [
		16174,
		9,
		16174
	],
	"./red-heart.svg": [
		97232,
		9,
		97232
	],
	"./social/FB.svg": [
		69508,
		9,
		69508
	],
	"./social/FB2.svg": [
		76068,
		9,
		76068
	],
	"./social/Twiter.svg": [
		79683,
		9,
		79683
	],
	"./social/Twiter2.svg": [
		76108,
		9,
		76108
	],
	"./social/backIcon1.svg": [
		82502,
		9,
		82502
	],
	"./social/backIcon2.svg": [
		44887,
		9,
		44887
	],
	"./social/discord": [
		71479,
		9
	],
	"./social/discord.js": [
		71479,
		9
	],
	"./social/discord.svg": [
		86209,
		9,
		86209
	],
	"./social/discord2.svg": [
		92793,
		9,
		92793
	],
	"./social/linkedin.svg": [
		46137,
		9,
		46137
	],
	"./social/linkedin2.svg": [
		90445,
		9,
		90445
	],
	"./social/share.svg": [
		27963,
		9,
		27963
	],
	"./solutions/cards/DeFi.avif": [
		34106,
		9
	],
	"./solutions/cards/GameFi.avif": [
		76126,
		9
	],
	"./solutions/cards/Web3CommerceImage.avif": [
		86776,
		9
	],
	"./solutions/cards/Web3FundManagementImage.avif": [
		23227,
		9
	],
	"./solutions/defi/DeFiBanner.avif": [
		65947,
		9
	],
	"./solutions/defi/DeFiBanneriPhone.avif": [
		44078,
		9
	],
	"./solutions/defi/MasterUserData.png": [
		66609,
		9,
		66609
	],
	"./solutions/defi/MasterUserData.svg": [
		9836,
		9,
		9836
	],
	"./solutions/defi/MasterUserData.webp": [
		57346,
		9,
		57346
	],
	"./solutions/defi/SubDesc1.svg": [
		32215,
		9,
		32215
	],
	"./solutions/defi/SubDesc2.svg": [
		60484,
		9,
		60484
	],
	"./solutions/defi/SubDesc3.svg": [
		14096,
		9,
		14096
	],
	"./solutions/defi/SubDesc4.svg": [
		80987,
		9,
		80987
	],
	"./solutions/defi/Swiper0.png": [
		44470,
		9,
		44470
	],
	"./solutions/defi/Swiper1.png": [
		25566,
		9,
		25566
	],
	"./solutions/defi/Swiper1.webp": [
		40508,
		9,
		40508
	],
	"./solutions/defi/Swiper2.png": [
		45469,
		9,
		45469
	],
	"./solutions/defi/Swiper3.png": [
		89623,
		9,
		89623
	],
	"./solutions/defi/Swiper3.webp": [
		25046,
		9,
		25046
	],
	"./solutions/defi/TAGBanner.webp": [
		1256,
		9,
		1256
	],
	"./solutions/gamefi/CaseStickey.png": [
		55890,
		9,
		55890
	],
	"./solutions/gamefi/CaseStickey.webp": [
		93054,
		9,
		93054
	],
	"./solutions/gamefi/GameFiBanner.avif": [
		38095,
		9
	],
	"./solutions/gamefi/GameFiBanneriPhone.avif": [
		80890,
		9
	],
	"./solutions/gamefi/SubDesc1.svg": [
		30337,
		9,
		30337
	],
	"./solutions/gamefi/SubDesc2.svg": [
		87786,
		9,
		87786
	],
	"./solutions/gamefi/SubDesc3.svg": [
		47204,
		9,
		47204
	],
	"./solutions/gamefi/SubDesc4.svg": [
		61114,
		9,
		61114
	],
	"./solutions/gamefi/Swiper1.png": [
		25953,
		9,
		25953
	],
	"./solutions/gamefi/Swiper1.webp": [
		23826,
		9,
		23826
	],
	"./solutions/gamefi/Swiper2.png": [
		15757,
		9,
		15757
	],
	"./solutions/gamefi/Swiper2.webp": [
		59587,
		9,
		59587
	],
	"./solutions/gamefi/Swiper3.png": [
		90994,
		9,
		90994
	],
	"./solutions/gamefi/Swiper3.webp": [
		23666,
		9,
		23666
	],
	"./solutions/web3-fund-management/banner.avif": [
		95134,
		9
	],
	"./solutions/web3-fund-management/banneriPhone.avif": [
		61289,
		9
	],
	"./solutions/web3-fund-management/blog-fake-cover.avif": [
		21849,
		9
	],
	"./solutions/web3-fund-management/defi-k-line.svg": [
		4812,
		9,
		4812
	],
	"./solutions/web3-fund-management/global-exchange.svg": [
		19283,
		9,
		19283
	],
	"./solutions/web3-fund-management/guardMoney.svg": [
		86543,
		9,
		86543
	],
	"./solutions/web3-fund-management/low-transaction-fees.svg": [
		9550,
		9,
		9550
	],
	"./solutions/web3-fund-management/money.svg": [
		93812,
		9,
		93812
	],
	"./solutions/web3-fund-management/payment-fake-cover.avif": [
		33633,
		9
	],
	"./solutions/web3-fund-management/secure.svg": [
		54090,
		9,
		17775
	],
	"./solutions/web3-fund-management/shopping-store.svg": [
		8589,
		9,
		19190
	],
	"./solutions/web3-fund-management/stablecoin.svg": [
		23544,
		9,
		23544
	],
	"./solutions/web3-fund-management/tether.svg": [
		86159,
		9,
		86159
	],
	"./success.svg": [
		30340,
		9,
		30340
	],
	"./ui/ArrowDown1.svg": [
		87248,
		9,
		87248
	],
	"./ui/ArrowDown2.svg": [
		31009,
		9,
		31009
	],
	"./ui/ArrowTop1.svg": [
		93958,
		9,
		93958
	],
	"./ui/ArrowTop2.svg": [
		75328,
		9,
		75328
	],
	"./ui/check.svg": [
		34720,
		9,
		34720
	],
	"./walletAsAService/APK.svg": [
		85243,
		9,
		85243
	],
	"./walletAsAService/Chrome.svg": [
		74523,
		9,
		16200
	],
	"./walletAsAService/Google.svg": [
		71012,
		9,
		71012
	],
	"./walletAsAService/HoverAPK.svg": [
		8488,
		9,
		8488
	],
	"./walletAsAService/HoverChrome.svg": [
		14113,
		9,
		14113
	],
	"./walletAsAService/HoverGoogle.svg": [
		54849,
		9,
		54849
	],
	"./walletAsAService/HoverIOS.svg": [
		49672,
		9,
		49672
	],
	"./walletAsAService/IOS.svg": [
		86805,
		9,
		86805
	],
	"./walletAsAService/feature/1.svg": [
		10357,
		9,
		10357
	],
	"./walletAsAService/feature/10.svg": [
		94732,
		9,
		94732
	],
	"./walletAsAService/feature/11.svg": [
		78144,
		9,
		78144
	],
	"./walletAsAService/feature/12.svg": [
		36468,
		9,
		36468
	],
	"./walletAsAService/feature/2.svg": [
		38185,
		9,
		38185
	],
	"./walletAsAService/feature/3.svg": [
		37785,
		9,
		37785
	],
	"./walletAsAService/feature/4.svg": [
		30321,
		9,
		30321
	],
	"./walletAsAService/feature/5.svg": [
		75463,
		9,
		75463
	],
	"./walletAsAService/feature/6.svg": [
		642,
		9,
		642
	],
	"./walletAsAService/feature/7.svg": [
		79197,
		9,
		79197
	],
	"./walletAsAService/feature/8.svg": [
		73674,
		9,
		73674
	],
	"./walletAsAService/feature/9.svg": [
		352,
		9,
		352
	],
	"./walletAsAService/feature1.webp": [
		42707,
		9,
		42707
	],
	"./walletAsAService/feature2.webp": [
		164,
		9,
		164
	],
	"./walletAsAService/feature4.webp": [
		43528,
		9,
		43528
	],
	"./walletAsAService/hero/BGstar.png": [
		9621,
		9,
		9621
	],
	"./walletAsAService/hero/BGstar.webp": [
		37274,
		9,
		37274
	],
	"./walletAsAService/hero/Star.svg": [
		64352,
		9,
		64352
	],
	"./walletAsAService/hero/coin1.svg": [
		57663,
		9,
		57663
	],
	"./walletAsAService/hero/coin2.svg": [
		91142,
		9,
		91142
	],
	"./walletAsAService/hero/coin3.svg": [
		66456,
		9,
		66456
	],
	"./walletAsAService/hero/diamond.png": [
		2837,
		9,
		26710
	],
	"./walletAsAService/hero/diamond.svg": [
		80897,
		9,
		80897
	],
	"./walletAsAService/hero/popLeft.svg": [
		23940,
		9,
		23940
	],
	"./walletAsAService/hero/popRight.svg": [
		55531,
		9,
		55531
	],
	"./walletAsAService/hero/shiny.svg": [
		16479,
		9,
		16479
	],
	"./walletAsAService/heroImage.webp": [
		53185,
		9,
		53185
	],
	"./walletAsAService/sectionWhiteWallet.webp": [
		27439,
		9,
		27439
	],
	"./walletAsAService/showCase/KGLOGO.webp": [
		67747,
		9,
		67747
	],
	"./walletAsAService/showCase/TAGLOGO.webp": [
		79855,
		9,
		79855
	],
	"./walletAsAService/showCase/YGGJLOGO.webp": [
		98871,
		9,
		98871
	],
	"./walletAsAService/showCase/hero&banner/KG Banner.webp": [
		3780,
		9,
		3780
	],
	"./walletAsAService/showCase/hero&banner/KG Hero.webp": [
		20902,
		9,
		20902
	],
	"./walletAsAService/showCase/hero&banner/TAG Banner.webp": [
		4408,
		9,
		4408
	],
	"./walletAsAService/showCase/hero&banner/TAG Hero.webp": [
		63008,
		9,
		63008
	],
	"./walletAsAService/showCase/hero&banner/YGGJ Banner.webp": [
		94328,
		9,
		94328
	],
	"./walletAsAService/showCase/hero&banner/YGGJ Hero.webp": [
		11071,
		9,
		11071
	],
	"./walletAsAService/showCase/premise/KG1.svg": [
		78855,
		9,
		78855
	],
	"./walletAsAService/showCase/premise/KG2.svg": [
		42143,
		9,
		42143
	],
	"./walletAsAService/showCase/premise/KG3.svg": [
		20841,
		9,
		20841
	],
	"./walletAsAService/showCase/premise/TAG1.svg": [
		65330,
		9,
		65330
	],
	"./walletAsAService/showCase/premise/TAG2.svg": [
		79014,
		9,
		79014
	],
	"./walletAsAService/showCase/premise/TAG3.svg": [
		2730,
		9,
		2730
	],
	"./walletAsAService/showCase/premise/Vector.svg": [
		76588,
		9,
		76588
	],
	"./walletAsAService/showCase/premise/YGGJ1.svg": [
		63635,
		9,
		72684
	],
	"./walletAsAService/showCase/premise/YGGJ2.svg": [
		77380,
		9,
		77380
	],
	"./walletAsAService/showCase/premise/YGGJ3.svg": [
		3147,
		9,
		3147
	],
	"./walletAsAService/showCase/premise/lineGroupB.svg": [
		43944,
		9,
		43944
	],
	"./walletAsAService/showCase/premise/lineGroupG.svg": [
		69906,
		9,
		69906
	],
	"./walletAsAService/showCase/premise/lineGroupY.svg": [
		77885,
		9,
		77885
	],
	"./walletAsAService/showCase/solutions/KG1.webp": [
		76031,
		9,
		76031
	],
	"./walletAsAService/showCase/solutions/KG2.webp": [
		87357,
		9,
		87357
	],
	"./walletAsAService/showCase/solutions/KG3.webp": [
		6155,
		9,
		6155
	],
	"./walletAsAService/showCase/solutions/KG4.webp": [
		82942,
		9,
		82942
	],
	"./walletAsAService/showCase/solutions/KG5.webp": [
		63851,
		9,
		63851
	],
	"./walletAsAService/showCase/solutions/TAG1.webp": [
		68257,
		9,
		68257
	],
	"./walletAsAService/showCase/solutions/TAG2.webp": [
		77768,
		9,
		77768
	],
	"./walletAsAService/showCase/solutions/TAG3.webp": [
		50143,
		9,
		50143
	],
	"./walletAsAService/showCase/solutions/YGGJ1.webp": [
		42141,
		9,
		42141
	],
	"./walletAsAService/showCase/solutions/YGGJ2.webp": [
		1214,
		9,
		1214
	],
	"./walletAsAService/showCase/solutions/YGGJ3.webp": [
		41181,
		9,
		41181
	],
	"./whyWorkHere/KryptoGO Cover.webp": [
		48884,
		9,
		48884
	],
	"./whyWorkHere/KryptoGOCover.webp": [
		34568,
		9,
		34568
	],
	"./whyWorkHere/Team_new.webp": [
		51256,
		9,
		51256
	],
	"./whyWorkHere/coWorker.webp": [
		76575,
		9,
		76575
	],
	"./whyWorkHere/decision.webp": [
		34058,
		9,
		34058
	],
	"./whyWorkHere/meetingRoom.webp": [
		86149,
		9,
		86149
	],
	"./whyWorkHere/pantry.webp": [
		25777,
		9,
		25777
	],
	"./whyWorkHere/teamPhoto.webp": [
		76739,
		9,
		76739
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 88550;
module.exports = webpackAsyncContext;